export default __webpack_public_path__ + "static/media/102.deaafef6.gif";